import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Card,
  Form,
  Col,
  Divider,
  Spin,
  DatePicker,
  Button,
  Typography,
} from "antd";

//ANT DESIGN ICONS IMPORT
import { LeftOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from "dayjs";

//PROJECT IMPORTS
import { BOM } from "../../../../../../../services/definedMethod";
import cnt from "../../../../../../../services/definedConstant";
import CustomButton from "../../../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../../components/layouts/TopContent";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../../group.config";
import { accountStatus } from "../../../../../../../components/facilities/AccountFacility";

const Reject = (props) => {
  const { TextArea } = Input;
  const { userData } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [currentOfficerOptions, setCurrentOfficerOptions] = useState([]);
  const [templateDetail, setTemplateDetail] = useState();
  const dateFormat = "YYYY/MM/DD";

  useEffect(() => {
    defaultDate();
    getDetailById();
  }, []);

  function onCancel() {
    navigate("/detail-gsim-account", { state: state });
  }
  const defaultDate = () => {
    form.setFieldsValue({
      rejectedOnDate: dayjs(),
    });
  };
  const getDetailById = () => {
    const params = {
      associations: "all",
    };
    const url = `${apiConfig.SavingsAccounts}/${state.childGSIMAccountId}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCurrentOfficer = [];

        setTemplateDetail(objDetail);

        objDetail?.fieldOfficerOptions?.forEach((element) => {
          tempCurrentOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });
        setCurrentOfficerOptions(tempCurrentOfficer);
        setIsLoading(false);
      }
    });
  };

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };
  const onSubmit = (formValues) => {
    const url = `${apiConfig.SavingsAccounts}/${state.childGSIMAccountId}`;
    const params = {
      command: "reject",
    };
    formValues.rejectedOnDate = BOM.DateTime(
      formValues.rejectedOnDate,
      "only-date"
    );

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectSavingsAccountMsg);
        navigate("/detail-gsim-account", {
          state: { ...state, statusValue: accountStatus.rejected },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.rejectSavingsGrp}
        pageItems={staticConfig.rejectSavingsGrpBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state.childAccountNo}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.rejectedOnDate}
                  name="rejectedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledAfterCurrentDate}
                    style={{ width: "100%", height: 35 }}
                    format={dateFormat}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.note} name="note">
                  <TextArea rows={3} />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default Reject;
